// CityCard.js
import React from 'react';
import { Box, Container, Grid, Typography, useTheme } from '@mui/material';
import { CommonHeading } from '../../../../layout/Common';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import EmailIcon from '@mui/icons-material/Email';
import AccessTimeIcon from '@mui/icons-material/AccessTime';



const CityCard = () => {

  const theme = useTheme();


  const cityData = [
    {
      city: 'Surat',
      address: 'U-72 1st floor raj mahal AC mall near sita Nagar circle puna gam Rod, Gujarat Surat,-395010',
      phone: '+91 9099126650',
      email: 'nakranimahesh102@gmail.com',
      hours: 'Mon-Sun: 8 AM - 5 PM',
      imgSrc: 'path-to-canberra-skyline-image',
    },
  ];

  return (
    <Box sx={{ backgroundColor: '#000', padding: { sm: '50px 50px 120px 50px', xs: '20px 10px' } }}>
      <Container maxWidth='xxl'>
        <Grid container spacing={6} direction="column">
          {cityData.map((city, index) => (
            <Grid container item spacing={4} key={index} alignItems="center">
              {/* Image Left */}
              <Grid item xs={12} md={6}>
                <Box
                  sx={{
                    '&:hover .city-image': {
                      mb: 0,
                    },
                  }}
                >
                  <Box className='city-image' sx={{ mb: 2, transition: '0.5s all ease' }}>
                    <img
                      src='/images/Contact/contact-image-2.jpg'
                      alt='city'
                      style={{ width: '100%', height: 'auto', objectFit: 'cover' }}
                    />
                  </Box>
                </Box>
              </Grid>

              {/* Content Right */}
              <Grid item xs={12} md={6}>
                <Box sx={{ backgroundColor: theme.palette.background.brownDark, padding: '34px' }}>
                  <Typography
                    sx={{
                      fontFamily: theme.palette.typography.fontFamily1,
                      fontSize: '38px',
                      color: '#fff',
                      fontWeight: 500,
                      mb: '20px',
                    }}
                  >
                    {city.city}
                  </Typography>
                  <Typography
                    sx={{
                      fontFamily: theme.palette.typography.fontFamily1,
                      fontSize: '16px',
                      color: '#fff',
                      width: '70%',
                      mb: 3,
                    }}
                  >
                    {city.address}
                  </Typography>

                  <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                    <LocalPhoneIcon sx={{ color: theme.palette.primary.gold, pr: 1, fontSize: '20px' }} />
                    <Typography
                      sx={{
                        fontFamily: theme.palette.typography.fontFamily1,
                        fontSize: '16px',
                        color: '#fff',
                      }}
                    >
                      {city.phone}
                    </Typography>
                  </Box>

                  <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                    <EmailIcon sx={{ color: theme.palette.primary.gold, pr: 1, fontSize: '20px' }} />
                    <Typography
                      sx={{
                        fontFamily: theme.palette.typography.fontFamily1,
                        fontSize: '16px',
                        color: '#fff',
                      }}
                    >
                      {city.email}
                    </Typography>
                  </Box>

                  <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                    <AccessTimeIcon sx={{ color: theme.palette.primary.gold, pr: 1, fontSize: '20px' }} />
                    <Typography
                      sx={{
                        fontFamily: theme.palette.typography.fontFamily1,
                        fontSize: '16px',
                        color: '#fff',
                      }}
                    >
                      {city.hours}
                    </Typography>
                  </Box>
                </Box>
              </Grid>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>


  );
};

export default CityCard;
